<div class="wrapper">
  <cs-icon-button
    class="btn-close"
    iconType="icon"
    icon="fi-x"
    color="secondary"
    size="12"
    (buttonClick)="close()"
  ></cs-icon-button>
  <div class="heading">{{ title }}</div>
  <div class="container">
    <form [formGroup]="form" class="form" autocomplete="off" novalidate>
      <div class="scroll-cont">
        <div class="section">
          <div class="cont">
            <div class="row">
              <div class="item">
                <div class="label">
                  <span>Enter your email</span>
                </div>
                <cs-input
                  formControlName="email"
                  placeholder="your@email.com"
                  prefixIconName="fi-user-filled"
                  autocomplete="email"
                  [readonly]="!requireEmail"
                  [hasError]="hasError('email')"
                  errorHint="Enter a valid email"
                ></cs-input>
              </div>
            </div>

            <div class="row">
              <div class="item">
                <div class="label">
                  <span>Name</span>
                </div>
                <cs-input
                  formControlName="name"
                  placeholder="Name"
                  autocomplete="given-name"
                  [hasError]="hasError('name')"
                  errorHint="This field is required"
                ></cs-input>
              </div>

              <div class="item">
                <div class="label">
                  <span>Surname</span>
                </div>
                <cs-input
                  formControlName="surname"
                  placeholder="Surname"
                  autocomplete="family-name"
                  [hasError]="hasError('surname')"
                  errorHint="This field is required"
                ></cs-input>
              </div>
            </div>

            <div class="row">
              <div class="item dob-item">
                <div class="label">
                  <span>Date of birth</span>
                </div>
                <cs-input
                  formControlName="dateOfBirth"
                  placeholder="DD/MM/YYYY"
                  autocomplete="bday"
                  inputMode="numeric"
                  [maxLength]="10"
                  [hasError]="!!getDateOfBirthError()"
                  [errorHint]="getDateOfBirthError()"
                  [format]="formatDateOfBirthInput"
                  (inputFocus)="onDateOfBirthFocus()"
                  (inputClick)="onDateOfBirthFocus()"
                ></cs-input>
                @if (isMobileDevice) {
                  <input
                    #nativeDobInput
                    class="native-dob-picker"
                    type="date"
                    tabindex="-1"
                    aria-hidden="true"
                    [value]="nativeDateValue"
                    (change)="onNativeDateChange($event)"
                  />
                }
              </div>
            </div>

            <div class="row">
              <div class="item">
                <div class="label">
                  <span>Street</span>
                </div>
                <cs-input
                  formControlName="street"
                  placeholder="Street"
                  autocomplete="address-line1"
                  [hasError]="hasError('street')"
                  errorHint="This field is required"
                ></cs-input>
              </div>
            </div>

            <div class="row">
              <div class="item">
                <div class="label">
                  <span>City</span>
                </div>
                <cs-input
                  formControlName="city"
                  placeholder="City"
                  autocomplete="address-level2"
                  [hasError]="hasError('city')"
                  errorHint="This field is required"
                ></cs-input>
              </div>
              <div class="item">
                <div class="label">
                  <span>Postcode</span>
                </div>
                <cs-input
                  formControlName="postcode"
                  autocomplete="postal-code"
                  [hasError]="hasError('postcode')"
                  errorHint="Enter a valid postcode"
                ></cs-input>
              </div>
            </div>

            <div class="row">
              <div class="item">
                <div class="label">
                  <span>Country</span>
                </div>
                <cs-select
                  [options]="countryOptions"
                  [value]="countryControl.value"
                  placeholder="Select country"
                  optionWidth="full"
                  [searchTarget]="['label', 'value']"
                  (valueChange)="selectCountry($event)"
                ></cs-select>
                @if (countryHasError()) {
                  <div class="error">Select your country</div>
                }
              </div>
            </div>
          </div>

          @if (requireTerms) {
            <div class="terms-check">
              <label class="terms-label">
                <input type="checkbox" formControlName="agreeTerms" />
                <span>I accept the</span>
                <span class="link" (click)="jumpToAgree($event)"> terms and conditions </span>
                <span>and the</span>
                <span class="link" (click)="jumpToPolicy($event)"> privacy policy. </span>
              </label>
              @if (termsHasError()) {
                <div class="error">You must accept the terms and conditions.</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="footer">
        <cs-button
          label="Continue"
          size="large"
          color="primary"
          [loading]="loading"
          [disabled]="loading || (formSubmitted && form.invalid)"
          (buttonClick)="submit()"
        ></cs-button>
      </div>
    </form>
  </div>
</div>
